<template>
  <div class="input-letter-text">
    <label class="input-letter-text__label">
      <span class="input-letter-text__title">{{ title }}</span>
      <div class="input-letter-text__field">
        <input
          class="input-letter-text__input"
          type="text"
          v-bind:class="{ right: alignRight }"
          v-bind:disabled="disabled"
          v-bind:maxlength="maxlength"
          v-bind:pattern="pattern"
          v-bind:required="isRequired"
          v-bind:style="inputStyle"
          v-bind:value="value"
          v-mask="mask"
          v-on:input="onInput"
        />
        <div class="input-letter-text__container">
          <span class="input-letter-text__char" v-for="i in +maxlength" v-bind:key="i" />
        </div>
      </div>
    </label>
    <p
      class="input-letter-text__violation"
      role="alert"
      v-for="violationText in violations"
      v-bind:key="violationText"
    >
      {{ violationText }}
    </p>
  </div>
</template>

<script>
/**
 * @description Компонент ввода интервального текста.
 */
export default {
  computed: {
    isRequired() {
      return !this.optional;
    },
    inputStyle() {
      const length = +this.maxlength;
      return {
        width: `${length * 25.5}px`,
      };
    },
  },
  name: 'InputLetterText',
  methods: {
    /**
     * @description Обработать ввод.
     * @param {InputEvent} event
     * @returns {void}
     */
    onInput(event) {
      this.$emit('input', event.target.value);
    },
  },
  props: {
    alignRight: {
      default: () => false,
      type: Boolean,
    },
    disabled: {
      default: () => false,
      type: Boolean,
    },
    mask: {
      default: () => '',
      type: [String, Function],
    },
    maxlength: {
      required: true,
      type: [String, Number],
    },
    optional: {
      default: () => false,
      type: Boolean,
    },
    pattern: {
      default: () => false,
      type: [Boolean, String],
    },
    title: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: String,
    },
    violations: {
      default: () => [],
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
$input-height: 2em;

.input-letter-text {
  display: flex;
  flex-direction: column;
  font-family: "Roboto Mono", monospace;

  &__label {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  &__title {
    font-weight: 400;
    color: #90A0B7;
    font-size: 14px;
  }
  &__field {
    position: relative;
    pointer-events: none;
  }
  &__container {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    gap: 0;
    padding: 0;
    z-index: 0;
  }
  &__input {
    margin: 0 0 0 8px;
    pointer-events: all;
    z-index: 1;
    width: 100%;
    padding: 0;
    height: $input-height;
    font-kerning: none;
    letter-spacing: 1rem;
    border: none;
    outline: none;
    appearance: none;
    background-color: transparent;
    line-height: $input-height;

    &:focus {
      outline: none;
    }

    &.right {
      text-align: right;
      margin: 0 8px;
    }
  }
  &__char {
    width: 25.6px;
    height: $input-height;
    border: 1px dotted black;
    flex-shrink: 0;
    z-index: -1;
  }

  &__violation {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    padding: 0.125rem;
  }
}
</style>
